import { render, staticRenderFns } from "./Section12.vue?vue&type=template&id=5cf6f54e&scoped=true&"
import script from "./Section12.vue?vue&type=script&lang=js&"
export * from "./Section12.vue?vue&type=script&lang=js&"
import style0 from "./Section12.vue?vue&type=style&index=0&id=5cf6f54e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf6f54e",
  null
  
)

export default component.exports